/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Project_TitleInputs */

const en_agent_authorization_project_title = /** @type {(inputs: Agent_Authorization_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project submitted by the Agent`)
};

const zh_agent_authorization_project_title = /** @type {(inputs: Agent_Authorization_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 提交的项目`)
};

/**
* | output |
* | --- |
* | "Project submitted by the Agent" |
*
* @param {Agent_Authorization_Project_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_project_title = /** @type {((inputs?: Agent_Authorization_Project_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Project_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_project_title(inputs)
	return zh_agent_authorization_project_title(inputs)
});
export { agent_authorization_project_title as "agent.authorization.project_title" }